/**
 * Code 39 條碼編碼（王道銀行超商代收三段條碼用），從 lpg-admin-web 帳單列印 BillView/code39.js 搬來。
 * 每個字元 9 個元素（條/空交錯、條開頭），其中 3 個寬；字元之間隔一個窄空白，前後加起止字元 '*'。
 * 超商條碼只會用到數字與大寫英文。
 */
const PATTERNS: Record<string, string> = {
  0: "000110100",
  1: "100100001",
  2: "001100001",
  3: "101100000",
  4: "000110001",
  5: "100110000",
  6: "001110000",
  7: "000100101",
  8: "100100100",
  9: "001100100",
  A: "100001001",
  B: "001001001",
  C: "101001000",
  D: "000011001",
  E: "100011000",
  F: "001011000",
  G: "000001101",
  H: "100001100",
  I: "001001100",
  J: "000011100",
  K: "100000011",
  L: "001000011",
  M: "101000010",
  N: "000010011",
  O: "100010010",
  P: "001010010",
  Q: "000000111",
  R: "100000110",
  S: "001000110",
  T: "000010110",
  U: "110000001",
  V: "011000001",
  W: "111000000",
  X: "010010001",
  Y: "110010000",
  Z: "011010000",
  "*": "010010100",
};

/** 寬窄比（Code 39 規格 2 ~ 3，取 3 掃描容錯最好） */
export const WIDE_RATIO = 3;

export interface Code39Bar {
  x: number;
  w: number;
}

/**
 * 把文字編成條寬序列：回傳 bars（只列「條」，空白由間距表示）與總寬，單位＝窄條寬。
 * 含前後 '*'；不支援的字元直接 throw（條碼內容由後端產生，出現就是資料有問題）。
 */
export const encodeCode39 = (text: string): { bars: Code39Bar[]; width: number } => {
  const chars = `*${text}*`.split("");
  const bars: Code39Bar[] = [];
  let x = 0;
  chars.forEach((ch, ci) => {
    const pattern = PATTERNS[ch];
    if (!pattern) throw new Error(`Code 39 不支援的字元：${ch}`);
    pattern.split("").forEach((bit, i) => {
      const w = bit === "1" ? WIDE_RATIO : 1;
      if (i % 2 === 0) bars.push({ x, w });
      x += w;
    });
    if (ci < chars.length - 1) x += 1; // 字元間隔
  });
  return { bars, width: x };
};
